import { render, staticRenderFns } from "./PaymentDetailSDD.vue?vue&type=template&id=07dba13a&"
import script from "./PaymentDetailSDD.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailSDD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports